export default __webpack_public_path__ + "eb3d0d5a749cf4ea28b8e6054ec44d1b.svg";